<template>
  <div class="period-header-controlls" ref="top">
    <section>

    <span class="period-pre-datepicker-text desktop">Период</span>
    <div class="period-datepicker">
      <div class="new-input-wrapper">
        <div class="new-input">
          <span class="mck">D</span>
          <input
            type="text"
            placeholder="От дата"
            @click="openDropdown(0)"
            @focus="openDropdown(0)"
            @blur="closeDropdown(0)"
            v-model="formatedDateFrom"
            readonly
          />
        </div>
      </div>
      <div class="new-input-wrapper">
        <div class="new-input">
          <span class="mck">D</span>
          <input
            type="text"
            placeholder="До дата"
            @click="openDropdown(1)"
            @focus="openDropdown(1)"
            @blur="closeDropdown(1)"
            v-model="formatedDateTo"
            readonly
          />
        </div>
      </div>
      <div
        class="new-input-dropdown datepicker-dropdown"
        :class="{ 'datepicker-dropdown-active': openedDropdown[0] }"
      >
        <datepicker
          :language="bg"
          :inline="true"
          :monday-first="true"
          :wrapper-class="'custom-datepicker'"
          :calendar-class="'custom-calendar'"
          v-model="period.dateFrom"
          @selected="closeDropdown(0), changeDatePeriod(null)"
        ></datepicker>
      </div>
      <div
        class="new-input-dropdown datepicker-dropdown"
        :class="{ 'datepicker-dropdown-active': openedDropdown[1] }"
      >
        <datepicker
          :language="bg"
          :inline="true"
          :monday-first="true"
          :wrapper-class="'custom-datepicker'"
          :calendar-class="'custom-calendar'"
          v-model="period.dateTo"
          @selected="closeDropdown(1), changeDatePeriod(null)"
        ></datepicker>
      </div>
    </div>
    </section>
<section>

    <div class="date-toggles">
      <span
        class="mck2 date-toggle"
        :class="{ 'date-toggle-active': datePeriod === 'today' }"
        @click="changeDatePeriod('today')"
        title="История за днес"
        >b</span
      >
      <span
        class="mck2 date-toggle"
        :class="{ 'date-toggle-active': datePeriod === 'yesterday' }"
        @click="changeDatePeriod('yesterday')"
        title="История за вчера"
        >c</span
      >
      <span
        class="mck2 date-toggle"
        :class="{ 'date-toggle-active': datePeriod === 'current' }"
        @click="changeDatePeriod('current')"
        title="История за текущия месец"
        >d</span
      >
      <span
        class="mck2 date-toggle"
        :class="{ 'date-toggle-active': datePeriod === 'previous' }"
        @click="changeDatePeriod('previous')"
        title="История за предишния месец"
        >e</span
      >
      <span
        class="mck2 date-toggle"
        :class="{ 'date-toggle-active': datePeriod === 'none' }"
        @click="changeDatePeriod('none')"
        title="История за всички времена"
        >*</span
      >
    </div>

    <slot>
    </slot>
</section>

  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import { bg } from "vuejs-datepicker/dist/locale";
import { format } from "date-fns";

export default {
  components: {
    Datepicker,
  },
  data() {
    return {
      bg,
      openedDropdown: [false, false],
      formatedDateFrom: null,
      formatedDateTo: null,
      datePeriod: "today",
      period: { dateFrom: null, dateTo: null },
    };
  },
  watch: {
    "period.dateFrom"(to) {
      if (to !== null) {
        this.period.dateFrom.setHours(0, 0, 0, 0);
        this.formatedDateFrom= format(new Date(this.period.dateFrom), 'dd/MM/yyyy')
      } else {
        this.formatedDateFrom = null;
      }
      this.emitUpdate();
    },
    "period.dateTo"(to) {
      if (to !== null) {
        this.period.dateTo.setHours(23, 59, 59, 999);
        this.formatedDateTo= format(new Date(this.period.dateTo), 'dd/MM/yyyy')
      } else {
        this.formatedDateTo = null;
      }
      this.emitUpdate();
    },
  },
  methods: {
    // Open dropdown. Depends on index (hard coded in template)
    openDropdown(i) {
      this.$set(this.openedDropdown, i, true);
    },
    // Close dropdown. Depends on index (hard coded in template)
    closeDropdown(i) {
      setTimeout(() => {
        this.$set(this.openedDropdown, i, false);
      }, 100);
    },
    changeDatePeriod(p) {
      this.datePeriod = p;
      if (p === "today") {
        this.setDays(0);
      } else if (p === "yesterday") {
        this.setDays(-1);
      } else if (p === "current") {
        this.setDates(0, -1);
      } else if (p === "previous") {
        this.setDates(1, 0);
      } else if (p === "none") {
        this.$set(this.period, "dateFrom", null);
        this.$set(this.period, "dateTo", null);
      }
      // this.queryObject.period = p;
      // this.$router.push({ query: this.queryObject });
    },
    setDates(from, to) {
      const date = new Date();
      // set first day of previous month
      this.period.dateFrom = new Date(
        date.getFullYear(),
        date.getMonth() - from,
        1
      );
      this.period.dateFrom.setHours(0, 0, 0, 0);
      // set last day of previous month
      this.period.dateTo = new Date(
        date.getFullYear(),
        date.getMonth() + to * -1,
        0
      );
      this.period.dateTo.setHours(23, 59, 59, 999);
    },
    setDays(d) {
      const date = new Date();
      // set first day of previous month
      this.period.dateFrom = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate() + d
      );
      this.period.dateFrom.setHours(0, 0, 0, 0);
      // set last day of previous month
      this.period.dateTo = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate() + d
      );
      this.period.dateTo.setHours(23, 59, 59, 999);
    },
    emitUpdate() {
      if (
        (this.period.dateFrom && this.period.dateTo) ||
        (!this.period.dateFrom && !this.period.dateTo)
      ) {
        this.$emit("update", this.period);
      }
    },
  },
  mounted() {
    this.changeDatePeriod("none");
  },
};
</script>

<style scoped lang="scss">
.period-header-controlls {
  align-items: center;
  display: flex;
  gap: 10px;
  width: 100%;

  section {
    align-items: center;
    justify-content: space-between;
    display: flex;

    &:last-of-type {
      width: 100%;
    }
  }
}

.period-pre-datepicker-text {
  color: #373737;
  display: inline-block;
  font-size: 11px;
  font-weight: 700;
  margin-right: 20px;
}
.period-datepicker {
  border-radius: 4px;
  display: flex;
  position: relative;
  width: 260px;
}
.period-datepicker .new-input-wrapper {
  background-color: #fff;
  margin: 0;
  width: 50%;
}
.period-datepicker .new-input-wrapper:first-child {
  border: 1px solid #dcdcdc;
  border-right: none;
  border-bottom-left-radius: 4px;
  border-top-left-radius: 4px;
}
.period-datepicker .new-input-wrapper:nth-child(2) {
  border: 1px solid #dcdcdc;
  border-left: none;
  border-bottom-right-radius: 4px;
  border-top-right-radius: 4px;
}
.period-datepicker .new-input {
  background-color: transparent;
  margin: 0;
}
.period-datepicker .new-input input {
  background-color: transparent;
  height: 30px;
  padding-right: 10px;
  cursor: pointer;
}
.period-datepicker .new-input input:not(:focus) {
  border: 1px solid transparent;
}
.period-datepicker .new-input input:focus {
  background-color: #f4f4f4;
  border: 1px solid var(--color-main);
}
.period-datepicker .new-input .mck {
  color: #8d3506;
}

.period-header-controlls .btns {
  align-items: center;
}

.new-input-dropdown {
  top: calc(100% + 5px);
}

.date-toggles {
  align-items: center;
  display: flex;
  gap: 10px;
}
.date-toggle {
  align-items: center;
  background-color: #ccd1e3;
  border: 1px solid #ccd1e3;
  border-radius: 4px;
  color: #8d3506;
  cursor: pointer;
  font-size: 20px;
  display: inline-flex;
  height: 30px;
  justify-content: center;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
  width: 30px;
  user-select: none;
}
.date-toggle:hover {
  border-color: rgba(141, 53, 6, 0.2);
}
.date-toggle-active,
.date-toggle-active:hover {
  background-color: #ffe0b2;
  border-color: #8d3506;
}

.mobile {
  display: none;
}

@media screen and (max-width: 1000px) {
  .period-header-controlls {
    flex-direction: column;

    section {
      width: 100%;
    }
  }
}
</style>
